import { useCallback } from "react";
import { useAuth } from "../contexts/AuthContext";
import TFTRecharge from "./TFTRecharge";
import TFTHistory from "./TFTHistory";
import { Wallet, Coins, TrendingUp } from "lucide-react";

export default function PassengerWallet() {
  const { user, checkAuth } = useAuth();
  const balance = Number(user?.tft_balance || 0);

  const refresh = useCallback(async () => {
    try {
      await checkAuth?.();
    } catch { /* noop */ }
  }, [checkAuth]);

  return (
    <div className="space-y-5" data-testid="passenger-wallet-panel">
      {/* Balance hero */}
      <div className="relative overflow-hidden bg-gradient-to-br from-[#0A2540] via-[#1E3A5F] to-[#0A2540] rounded-2xl p-6 text-white">
        <div className="absolute -right-8 -top-8 w-40 h-40 rounded-full bg-[#FACC15]/10 blur-2xl" />
        <div className="relative">
          <div className="flex items-center gap-2 mb-2">
            <Wallet className="w-5 h-5 text-[#FACC15]" />
            <h2 className="text-lg font-bold" style={{ fontFamily: 'Outfit' }}>Portefeuille TFT</h2>
          </div>
          <p className="text-xs text-white/60 uppercase tracking-wider mb-1">Solde disponible</p>
          <div className="flex items-baseline gap-2">
            <p className="text-4xl sm:text-5xl font-extrabold text-[#FACC15]" style={{ fontFamily: 'Outfit' }} data-testid="passenger-tft-balance">
              {Number(balance || 0).toLocaleString()}
            </p>
            <span className="text-base font-semibold text-white/80">TFT</span>
          </div>
          <p className="text-xs text-white/60 mt-1 flex items-center gap-1">
            <Coins className="w-3 h-3" /> 1 TFT = 1 XAF · Utilisez votre solde pour payer une réservation instantanément
          </p>
        </div>
      </div>

      <div className="bg-[#FACC15]/10 border border-[#FACC15]/30 rounded-xl p-4 flex items-start gap-3" data-testid="passenger-wallet-info">
        <TrendingUp className="w-4 h-4 text-[#0A2540] mt-0.5 shrink-0" />
        <p className="text-xs text-[#0A2540] leading-relaxed">
          Rechargez votre portefeuille via <strong>MTN Mobile Money</strong> ou <strong>Orange Money</strong>. La validation est manuelle (généralement &lt; 1h). Une fois crédité, payez le montant exact de vos réservations sans cash et <strong>recevez 2% de cashback TFT</strong> sur chaque réservation payée via votre portefeuille.
        </p>
      </div>

      {/* Recharge UI (works for both drivers and passengers) */}
      <TFTRecharge onBalanceChange={refresh} />

      {/* History */}
      <TFTHistory endpoint="/driver/tft/history" currentBalance={balance} title="Historique de mon portefeuille" />
    </div>
  );
}
